










// Vue
import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';
import RouteNames from '@/constants/route-names';

// Components
import Btn, {
    BtnColor,
    BtnWidth,
    BtnHeight,
    BtnFontSize,
    BtnPredefinedStyle,
} from '@/shared/components/btn.component.vue';
import ItemThumb, {
    ItemThumbPrefeginedStyle,
    TittleFontFamily,
    SubtitleFontFamily,
} from '@/shared/components/item-thumb.component.vue';
import Icon, {IconEnum} from '@/shared/components/icon.component.vue';
import Modal, {
    ModalTitleColor,
} from '@/shared/components/Modal.component.vue';

// Views
import FormView from '@/shared/views/form.view.vue';
import {Product} from '@/manager/product/models/product.model';

// Filters
import round from '@/shared/filters/round.filter.ts';

// Services
import BudgetService from '@/manager/budget/budget.service';

enum ProductTitleColor {
    LightGreen = 'product-container__title--light-green',
    Secondary = 'product-container__title--secondary',
    FlReen = 'product-container__title--fl-green',
    FlGreenMiddle = 'product-container__title--fl-green-middle',
}

@Component({
    components: {
        Btn,
        Icon,
        ItemThumb,
        FormView,
        Modal,
    },
    computed: {
        ...mapGetters({
            currentBudget: 'getCurrentBudgetAcceptance',
            acceptanceProductList: 'getCurrentBudgetAcceptanceProductList',
            acceptanceProductListContained:
                'getCurrentBudgetAcceptanceProductListContained',
            hasMoneyFlowDiscount: 'currentBudgetAcceptanceHasMoneyFlowDiscount',
        }),
    },
    filters: {
        round,
    },
})
export default class AcceptanceStart extends Vue {
    private assets = Assets;
    private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
    private tittleFontFamily = TittleFontFamily;
    private subtitleFontFamily = SubtitleFontFamily;
    private btnColor = BtnColor;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private btnWidth = BtnWidth;
    private btnHeight = BtnHeight;
    private btnFontSize = BtnFontSize;
    private modalTitleColor = ModalTitleColor;
    private productTitleColor = ProductTitleColor;
    private currentBudget!: any;
    private acceptanceProductListContained!: any;
    private acceptanceProductList!: any;
    private updateAcceptanceProductList!: any;
    private setAcceptanceProductList!: any;
    private budgetProductLoaded = true;
    private serverError = '';
    private iconEnum = IconEnum;
    private rejectBudgetModalOpened = false;
    private literals = {
        title: 'Aquí tienes tu alta',
        subtitle:
            'Sigue los pasos que verás a continuación para completar el proceso de aceptación del alta de tus productos:',
        discount: 'Saldo a favor',
        rejectButton: 'Rechazar alta',
        modalRejectBudget: {
            title: 'Rechar alta',
            text: '¿Estás seguro de que quieres rechazar tu alta?',
            btnReject: 'Rechazar',
            btnCancel: 'Cancelar',
        },
    };

    get cellSize() {
        let size = '8/12';

        if (this.hasDiscountApplied) {
            size = '6/12';
        }

        return size;
    }

    get asideBg() {
        return {
            'background-image': `url("${this.assets.navbarAcceptanceBg}")`,
            'background-size': `cover`,
        };
    }

    private pricingAppliedCalculated(line: any) {
        const tax = line.tax > 0 ? line.pricingApplied * (line.tax / 100) : 0;
        return line.pricingApplied + tax
    }

    get hasDiscountApplied() {
        return this.currentBudget.discount > 0;
    }

    private containedProducts(product: any) {
        return this.acceptanceProductListContained(product.id);
    }

    private productTitle(product: Product) {
        const title = {text: '', color: ''};
        if (product !== undefined) {
            if (product.acronym && product.acronym.includes('TLP')) {
                title.text = 'TLP';
                title.color = ProductTitleColor.FlReen;
            } else if (product.level > 3 || product.level === null) {
                title.text = 'Especialización';
                title.color = ProductTitleColor.LightGreen;
            } else if (product.level <= 3) {
                title.text = `Curso N.${product.level}`;
                // title.text = '';
                title.color = ProductTitleColor.LightGreen;
            }
        }
        return title;
    }

    private goToStep(step: string) {
        this.$router.push({
            name: RouteNames.BudgetAcceptance,
            params: {
                id: this.currentBudget.id,
                step,
            },
        });
    }

    private next() {
        this.goToStep('1');
    }

    private setRejectBudgetModalOpened(value: boolean) {
        this.rejectBudgetModalOpened = value;
    }

    private rejectBudget() {
        BudgetService.rejectBudget(this.currentBudget.id).then((res) => {
            this.$router.go(0);
        });
    }
}
